<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-10 class="text-left fw-500">10. Termination and Suspension</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-10" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Platform's Right to Terminate: RCPAY Virtual Account may terminate or suspend the VA with immediate effect for breach of these terms or suspicious activities.</li>
                        <li>User-Initiated Closure: The Account Holder may close their VA by providing written notice to RCPAY Virtual Account.</li>
                        <li>Effect of Termination: Upon termination, the Account Holder must cease all use of the VA. Any remaining funds will be returned to the Account Holder after deducting any applicable fees.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-10',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>